import React from 'react';
import ParliamentRedirect from '../ParliamentRedirect/ParliamentRedirect';

const VotingParliament: React.FC = () => {
    return <ParliamentRedirect parliamentName="Voting Parliament" />;
};

export default VotingParliament;
